import React, { useState } from 'react';
import { Button, ButtonProps } from 'antd';
import Iconfont from '@base/lib/Iconfont';
import delay from 'base/utils/delay';
import { IProduct } from 'base/interfaces/product';
import { IAddCartInstance } from '@base/product/useAddCart';

type IProps = {
    className?: string;
    product: IProduct;
    addCart?: IAddCartInstance
    onClick?: (product: IProduct) => Promise<void>;
    buttonType?: ButtonProps['type'];
}

const ListProductAddToCartBtn = React.forwardRef<HTMLDivElement, IProps>((props, ref) => {
    const {
        className,
        product,
        addCart,
        onClick,
        buttonType = 'text'
    } = props;

    const [loading, setLoading] = useState<boolean>(false)
    const [isSuccess, setIsSuccess] = useState<boolean>(false)
    const [isFailed, setIsFailed] = useState<boolean>(false)

    const {
        isStock
    } = product

    const {
        onSubmitWithVariant
    } = addCart || {}

    const onAddToCartHandle = async () => {
        try {
            setLoading(true)
            await onSubmitWithVariant?.(product, 1)
            await onClick?.(product);
            await delay(500)
            setIsSuccess(true)

        } catch (err) {
            setIsFailed(true)
        } finally {
            setLoading(false)
            await delay(1200)
            setIsSuccess(false)
            setIsFailed(false)
        }
    }

    return (
        <div className={className}>
            {/* 提交按钮 */}
            <div className={'add-to-cart-warp'}>
                <Button
                    className={'add-btn'}
                    loading={loading}
                    shape="circle"
                    type={buttonType}
                    disabled={!isStock}
                    icon={
                        <Iconfont
                            className={isSuccess ? 'icon-select'
                                : (isFailed ? 'icon-x' : 'icon-a-addtocart')
                            }
                        />
                    }
                    onClick={() => onAddToCartHandle()}
                />
            </div>
        </div>
    )
});

export default ListProductAddToCartBtn;